import ListBox from './ListBox';
import Collection from 'Support/Collection';
import UnsubscribesForm from './Forms/UnsubscribesForm';

export default class Unsubscribes extends ListBox {
    data() {
        return '/dashboard/profile/ajax/getUnsubscribes';
    }

    form() {
        return new UnsubscribesForm(this.loader);
    }

    process() {
        return function (data) {
            return { title: 'Unsubscribes', items: Collection.collect(data.unsubscribes).itemsOrNone() };
        };
    }

    load(containerId) {
        $(containerId).expandable('div.card');
        super.load(containerId);
    }
}
